import { render, staticRenderFns } from "./NoticeScreen.vue?vue&type=template&id=a6127d76&"
import script from "./NoticeScreen.vue?vue&type=script&lang=js&"
export * from "./NoticeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports